import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import ConfigContext
 from '../../utils/ConfigContext/ConfigContext';
import './DetailTable.scss';

const DetailTable = ( {
  id,
  tableInfo,
  tableDescription,
  className,
} ) => {
  if ( ( !tableInfo || tableInfo.length === 0 ) && ( !tableDescription || tableDescription === '' ) ) {
    return null;
  }

  return (

    <div id={id} className={ className }>
      <div className="detailTable">
        { tableInfo && tableInfo.length > 0 && (
          <div className="detailTable-list">
          { tableInfo.map( ( stat ) => (
            <div
              className={`detailTable-list__item detailTable-list__item--${stat.type}`}
              key={ stat.label }
            >
              <div className="detailTable-list__item__wrapper">

                {stat.label && (
                  <div className="detailTable-list__item__label">
                    { stat.label }
                    :
                  </div>
                )}

                {stat.data && (
                  <div className="detailTable-list__item__data" dangerouslySetInnerHTML={ { __html: stat.data } } />
                )}

                { stat.note && (
                  <div className="detailTable-list__item__note">
                    { stat.note }
                  </div>
                )}


                { stat.component && (
                  <div className="detailTable-list__item__component">
                    { stat.component }
                  </div>
                )}

              </div>
            </div>
          ) )}
          </div>
        )}

        { tableDescription && (tableDescription !== '') && (
          <p className="detailTable-description">
            { tableDescription }
          </p>
        )}
      </div>
    </div>
  );
};

DetailTable.propTypes = {
  id: PropTypes.string,
  tableInfo: PropTypes.arrayOf(
    PropTypes.shape( {
      label: PropTypes.string,
      data: PropTypes.string,
      note: PropTypes.string,
      component: PropTypes.element,
    } ),
  ),
  tableDescription: PropTypes.string,
  className: PropTypes.string,
};

DetailTable.defaultProps = {
  id: '',
  tableInfo: [],
  tableDescription: '',
  className: '',
};

export default DetailTable;
